<template>
  <div id="validate-account-view">
    <b-container>
      <b-row>
        <b-col>
          <div class="panel-light" style="text-align: center" v-if="loading">
            <h3>{{ $t("validate-email:validating") }}</h3>
          </div>
          <!-- ERROR -->
          <div
            class="panel text-center mt-5 p-5"
            v-if="!loading && error && !isLoggedIn">
            <div v-if="decodedToken">
              <h2>
                {{ $t("validate-email:could-not-process-already-validated") }}
              </h2>
              <p>
                <b-button
                  class="my-4"
                  to="/welcome/sign-in"
                  variant="success"
                  size="lg">
                  {{ $t("nav:sign-in") }}
                </b-button>
              </p>
              <p>{{ $t("validate-email:password-reset-cta-text") }}</p>
              <div v-show="!recoverDone">
                <b-button
                  class="my-2"
                  @click="recoverPassword"
                  variant="primary">
                    {{ $t("validate-email:password-reset-cta") }}
                </b-button>
              </div>
              <b-alert variant="success" :show="recoverDone">
                <span
                  v-html="$t('sign-in:recover-password__in-progress')">
                </span
              ></b-alert>
            </div>
            <div v-else>
              <h3>{{ $t("validate-email:could-not-process") }}</h3>
              <p>{{ $t("validate-email:could-not-process-reason-2") }}</p>
              <p v-html="$t('validate-email:could-not-process-help')"></p>
              <p>
                <b-button to="/welcome/sign-in" variant="success">
                  {{$t("validate-email:could-not-process-cta")}}
                </b-button>
              </p>
            </div>
          </div>
          <!-- ALREADY VALIDATED -->
          <div
            class="panel-light"
            v-if="!success && isLoggedIn"
            style="text-align: center"
          >
            <h3>{{ $t("validate-email:success") }}</h3>
            <br />
            <p v-if="!$store.state.user.name">
              <b-button to="/profile" variant="light">Fill in profile</b-button>
            </p>
            <p v-else>
              <b-button to="/personal/survey" variant="light">
                {{$t("common:continue")}}
              </b-button>
            </p>
          </div>
          <!-- SUCCESS -->
          <div
            class="panel mt-5 p-5 rounded"
            style="text-align: center"
            v-if="success">
            {{ $store.state.user }}
            <div class="full-overlay">
              <div class="overlay-header">
                <!-- Nav -->
                <b-container fluid>
                  <b-row align-h="center" align-v="center" class="my-md-4">
                    <b-col></b-col>
                    <b-col cols="7">
                      <div class="overlay-subnav text-center">
                        <!-- <b-button style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) === 0" variant="link"  :to="availableReports[availableReports.indexOf(openedReport)-1]"><icon scale="2" name="angle-left"/></b-button> -->
                        <span class="subnav-progress">
                          <span
                            class="item"
                            :key="index"
                            v-for="(step, index) in steps"
                            :class="{ active: step === currentStep }">
                          </span>
                        </span>
                        <!-- <b-button style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) >= availableReports.length -1" variant="link" :to="availableReports[availableReports.indexOf(openedReport)+1]"><icon scale="2" name="angle-right"/></b-button> -->
                      </div>
                    </b-col>
                    <b-col class="text-right">
                      <!-- <b-button variant="link" :to="closePath" id="close-button"><icon name="times" scale="2"/></b-button> -->
                    </b-col>
                  </b-row>
                </b-container>
              </div>
              <div class="overlay-content">
                <b-container fluid class="pt-0 pb-5 h-100">
                  <b-row align-h="center" align-v="center" class="h-100">
                    <b-col
                      v-if="currentStep == 'selectLanguage'"
                      align-self="center">
                      <b-row align-h="center" align-v="center">
                        <b-col
                          cols="12"
                          md="8"
                          lg="6"
                          class="mt-5 mb-5 text-center">
                          <h1>Hello, Hei!</h1>
                        </b-col>
                      </b-row>
                      <b-row
                        align-h="center"
                        align-v="center"
                        class="text-left">
                        <b-col cols="12" md="8" lg="6" class="mt-2 mb-5">
                          <language-changer />
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col v-if="currentStep == 'intro-why-bubblo+'" align-self="center">

                      <b-row align-h="center" align-v="center">
                        <b-col cols="12" md="8" lg="6" class="my-0 text-center">
                          <h2>
                            <icon
                              name="regular/smile"
                              scale="5"
                              style="color: #17b5cf"
                            />
                          </h2>
                        </b-col>
                      </b-row>
                      <b-row
                        align-h="center"
                        align-v="center"
                        class="text-left">
                        <b-col cols="12" md="8" lg="6" class="my-0">
                          <p
                            class="lead"
                            style="white-space: pre-line !important">
                            {{ $t("validate-email:intro-text-why-bubblo+") }}
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col v-if="currentStep == 'intro-how-bubblo+-helps-you'" align-self="center">
                      <b-row align-h="center" align-v="center">
                        <b-col cols="12" md="8" lg="6" class="my-0 text-center">
                          <h2>
                            <icon
                              name="regular/heart"
                              scale="5"
                              style="color: #17b5cf"
                            />
                          </h2>
                        </b-col>
                      </b-row>
                      <b-row
                        align-h="center"
                        align-v="center"
                        class="text-left">
                        <b-col cols="12" md="8" lg="6" class="my-0">
                          <p
                            class="lead"
                            style="white-space: pre-line !important">
                            {{$t("validate-email:intro-text-how-bubblo+-helps-you")}}
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col v-if="currentStep == 'intro-how-bubblo+-helps-work-communities'" align-self="center">
                      <b-row align-h="center" align-v="center">
                        <b-col cols="12" md="8" lg="6" class="my-0 text-center">
                          <h2>
                            <icon
                              name="users"
                              scale="5"
                              style="color: #17b5cf"
                            />
                          </h2>
                        </b-col>
                      </b-row>
                      <b-row
                        align-h="center"
                        align-v="center"
                        class="text-left">
                        <b-col cols="12" md="8" lg="6" class="my-0">
                          <p
                            class="lead"
                            style="white-space: pre-line !important">
                            {{$t("validate-email:intro-text-how-bubblo+-helps-work-communities")}}
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col
                      v-if="currentStep == 'intro-privacy'"
                      align-self="center">
                      <b-row align-h="center" align-v="center">
                        <b-col cols="12" md="8" lg="6" class="my-0 text-center">
                          <h2>
                            <icon
                              name="user-shield"
                              scale="5"
                              style="color: #17b5cf"
                            />
                          </h2>
                        </b-col>
                      </b-row>
                      <b-row
                        align-h="center"
                        align-v="center"
                        class="text-left">
                        <b-col cols="12" md="8" lg="6" class="my-0">
                          <p
                            class="lead"
                            style="white-space: pre-line !important">
                            {{ $t("validate-email:intro-text-privacy") }}
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col
                      v-if="currentStep == 'personalDetails'"
                      align-self="center">
                      <b-row align-h="center" align-v="center">
                        <b-col
                          cols="12"
                          md="8"
                          lg="6"
                          class="mt-5 mb-5 text-center">
                          <h2>
                            {{ $t("validate-email:title-personal-details") }}
                          </h2>
                        </b-col>
                      </b-row>
                      <b-row
                        align-h="center"
                        align-v="center"
                        class="text-left">
                        <b-col cols="12" md="8" lg="6" class="my-0">
                          <b-form @submit.prevent="updateProfile">
                            <b-form-group
                              :label="$t('profile:user-name-label') + ' (' + $t('common:optional') + ')'"
                              label-for="user-name">
                              <b-form-input
                                id="user-name"
                                name="user-name"
                                type="text"
                                v-model="user.name"
                                :placeholder="$t('profile:user-name-placeholder')">
                              </b-form-input>
                            </b-form-group>
                            <b-form-group class="text-center">
                              <b-button
                                size="lg"
                                id="submit-button_save-profile-details"
                                type="submit"
                                variant="success"
                                :disabled="updateProfileState.loading"
                                :class="{ loading: updateProfileState.loading }">
                                {{ $t("common:start") }}
                              </b-button>
                            </b-form-group>
                          </b-form>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col
                      cols="12"
                      class="text-center"
                      align-self="end"
                      v-if="currentStep !== 'personalDetails'">
                      <b-button size="lg" variant="success" @click="nextStep">
                        {{$t("common:continue")}}
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
              <div class="overlay-footer d-none d-md-block">
                <b-container fluid>
                  <b-row align-h="center">
                    <b-col class="text-center mt-3 mb-3 my-md-4"> </b-col>
                  </b-row>
                </b-container>
              </div>
            </div>

            <h3>{{ $t("validate-email:thank-you") }}</h3>
            <br />
            <p v-if="!$store.state.user.name">
              <b-button
                to="/profile/password?passwordRecovery=true"
                variant="success"
                size="lg">
                {{ $t("validate-email:fill-profile-cta") }}
              </b-button>
            </p>
            <p v-else>
              <b-button to="/personal/survey" variant="success">
                {{$t("common:continue")}}
              </b-button>
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'
import LanguageChanger from '../personal/profile/components/InlineLanguageChanger'

export default {
  name: 'ValidateAccount',
  data () {
    return {
      steps: ['selectLanguage', 'intro-why-bubblo+', 'intro-how-bubblo+-helps-you', 'intro-how-bubblo+-helps-work-communities', 'intro-privacy', 'personalDetails'],
      currentStep: 'selectLanguage',
      loading: true,
      error: false,
      success: false,
      recoverDone: false,
      profileUser: {},
      updateProfileState: {
        loading: false,
        success: false,
        failure: false
      }
    }
  },
  components: {
    LanguageChanger
  },
  methods: {
    recoverPassword: function () {
      this.axios
        .get('/auth/recover/' + this.decodedToken.emailValidation)
        .then((response) => {
          this.recoverDone = true
        })
        .catch(() => {
          this.recoverDone = true
        })
    },
    nextStep: function () {
      this.currentStep = this.steps[this.steps.indexOf(this.currentStep) + 1]
    },
    updateProfile () {
      this.updateProfileState.loading = true
      this.updateProfileState.failure = false
      this.updateProfileState.success = false
      this.axios
        .post('/users/' + this.$store.state.user._id, {
          user: this.profileUser
        })
        .then((response) => {
          this.$store.dispatch('updateUser', response.data.user)
          this.updateProfileState.success = true
          this.updateProfileState.loading = false
          this.$router.replace('Survey')
        })
        .catch(() => {
          this.updateProfileState.failure = true
          this.updateProfileState.loading = false
        })
    }
  },
  mounted: function () {
    if (this.$route.query.token) {
      this.$store
        .dispatch('validateAccount', this.$route.query.token)
        .then((res) => {
          this.loading = false
          this.success = true
          this.profileUser = this.$store.state.user
        })
        .catch(() => {
          this.error = true
          this.loading = false
          if (this.isLoggedIn) {
            this.$router.replace('Survey')
          }
        })
    } else {
      this.loading = false
      this.error = true
    }
    // this.loading = false
    // this.success = true
  },
  computed: {
    ...mapGetters(['user', 'isLoggedIn']),
    decodedToken: function () {
      try {
        if (this.$route.query.token) {
          return VueJwtDecode.decode(this.$route.query.token)
        }
        return null
      } catch {
        return null // VueJwtDecode throws an error for invalid tokens
      }
    }
  },
  watch: {
    user (value) {
      this.profileUser = value
    }
  }
}
</script>

<style lang="scss">
.lead-list {
  font-weight: 300;
  font-size: 1.05rem;
  list-style-position: outside;
  list-style-type: circle;
  padding: 1.5em 0 1.5em 1.5em;
  margin: 0;
  li {
    margin-bottom: 0.75em;
  }
}
</style>
